import {
  LoadingContainer,
  LegacyPage,
  Modal,
  Model,
  Panels,
  Bar,
  Input,
} from 'peach/components'
import { useParams } from 'peach/router'
import { LoanStatusSelect } from 'peach/scopes/loan'

import {
  useLoanDrawGet,
  useDrawUpdate,
  useInternalDrawActivate,
} from 'core/types'

const LoanDraw = () => {
  const { companyId, personId, loanId, drawId } = useParams<{
    companyId?: string
    personId?: string
    loanId?: string
    drawId?: string
  }>()

  const {
    data: draw,
    isLoading: isLoadingDraws,
    error: drawsError,
  } = useLoanDrawGet({
    personId,
    loanId,
    drawId,
    options: { enabled: !!(companyId && personId && loanId && drawId) },
  })

  const { mutateAsync: updateDraw, isPending: isUpdatingDraw } = useDrawUpdate({
    personId,
    loanId,
    drawId,
  })

  const { mutateAsync: activateDrawMutate, isPending: isActivatingDraw } =
    useInternalDrawActivate({
      companyId,
      personId,
      loanId,
      drawId,
    })

  const header = <Bar title='Draw' />

  const sendEditLoanDraw = async (_options, diff) => {
    try {
      await updateDraw(diff)
    } catch (err) {
      console.error('Error editing loan draw:', err)
    }
  }

  const sendActivateDraw = async () => {
    try {
      await activateDrawMutate(undefined)
    } catch (err) {
      console.error('Error activating draw:', err)
    }
  }

  return (
    <Panels header={header}>
      <Modal onSubmit={sendActivateDraw} title='Activate Draw' />
      <Modal
        initialValue={draw}
        onSubmit={sendEditLoanDraw}
        title='Edit Loan Draw'
      >
        <LoanStatusSelect formKey='status' />
        <Input formKey='nickname' />
      </Modal>
      <LoadingContainer
        error={drawsError}
        isLoading={isLoadingDraws || isUpdatingDraw || isActivatingDraw}
      >
        <LegacyPage.Full>
          <Model.Item json={draw} />
        </LegacyPage.Full>
      </LoadingContainer>
    </Panels>
  )
}

export default LoanDraw
